import { ReactComponent as FileUploadIcon } from '@/assets/img/v2/file-upload-icon.svg';
import './PetProfileCard.scss';
import { Pet } from '../types';
import { Form } from 'react-bootstrap';
import CatDefaultIcon from '@/assets/img/v2/pet-cat-default-icon.svg';
import DogDefaultIcon from '@/assets/img/v2/pet-dog-default-icon.svg';
import { ReactComponent as SelectedItemTick } from '@/assets/img/v2/selected-item.svg';

type PetProfileCardProps = {
  onSelect: (pet: Pet) => void;
  isSelected: boolean;
  data: Pet;
  hideSelect?: boolean;
};
export const PetProfileCard = ({
  onSelect,
  isSelected,
  data,
  hideSelect = false,
}: PetProfileCardProps) => {
  return (
    <div
      className={`pet-profile-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(data)}
    >
      <div className="pic-container">
        <img src={data.petsImageUrl ? data.petsImageUrl : data?.petType?.toLowerCase() == "cat" ? CatDefaultIcon : DogDefaultIcon} />
      </div>
      <p className="name">{data.name}</p>
      <p className="breed">{data.breed}</p>
      {!hideSelect && isSelected &&  (
        <SelectedItemTick />
      )}
    </div>
  );
};
